export default __webpack_public_path__ + "static/media/baner-top_haczyk_2027.09cf66b9.jpg";